<template>
    <Head>
        <title>Trámites y Servicios</title>
    </Head>
    <div class="hero-img-overlay hero-lila" style="background-image: url(/img/hero-tramites-servicios.png);background-color: #b29a66;">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Ventanilla de <br>Trámites y Servicios</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <a href="https://duenlinea.santiago.gob.mx/index.aspx" target="_blank">
                                <img loading="lazy"  class="img-fluid pb-5" :src="'/img/servicios/banner/Desarrollo-Urbano-Tramites.jpg'" alt="" />
                            </a>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="slider-tramites-servicios__encabezado">Trámites y Servicios frecuentes</div>
                        <div class="slider-tramites-servicios slick-initialized slick-slider">
                            <button @click="prev" class="slick-prev slick-arrow d-none d-md-block" aria-label="Previous" type="button" aria-disabled="true">Previous</button>
                            <carousel :settings="settings" :breakpoints="breakpoints" ref="itemsFrecuentes">
                                <slide v-for="(item, i) in frecuentes" :key="i" class="tramite-servicio-item">
                                    <img loading="lazy" width="63" height="55" class="tramite-servicio-item__icono" :src="'/img/icono-hexagono-' + item.secretaria.icono + '.svg'" alt="">
                                    <Link :href="`/servicio/` + item.slug" class="tramite-servicio-item__nombre" tabindex="0">{{ item.nombre }}</Link>
                                    <div class="tramite-servicio-item__secretaria">
                                        <Link :href="`/servicio/` + item.slug">{{ item.secretaria.nombre }}</Link>
                                    </div>
                                </slide>
                                <template #addons>
                                    <Pagination />
                                </template>
                            </carousel>
                            <button @click="next" class="slick-next slick-arrow d-none d-md-block" aria-label="Next" type="button" aria-disabled="true">Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="tramites-servicios__listado-encabezado">Listado de trámites y servicios</h2>
                        <div class="tramites-servicios__filtros">
                            <form @submit.prevent="searching()">
                                <div class="form-group">
                                    <input class="input-buscador" v-model="search" type="text" placeholder="Nombre del trámite o servicio ...">
                                </div>
                                <div class="form-group">
                                    <select class="form-control form__select" v-model="secretaria">
                                        <option value="" :selected="secretaria == ''">Todas las Secretarías
                                        </option>
                                        <option v-for="(item, i) in secretarias" :key="i" :value="item.id">{{ item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="form-group pl-3" style="line-height: 1.4em;display: flex;align-items: center;">
                                    <div style="width:130px;cursor: pointer;">
                                        <input style="cursor: pointer;" v-model="enlinea" value="si" type="checkbox" id="enlinea">
                                        <label style="display:inline;cursor: pointer;" class="inline" for="enlinea">En Línea</label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="submit" class="bot-buscar boton-principal ml-sm-4">Buscar</button>
                                </div>
                            </form>
                        </div>
                        <div class="tramites-servicios__listado">
                            <div v-if="servicios.data.length < 1">
                                <NoResults />
                            </div>
                            <Link v-for="(item, i) in servicios.data" :key="i" :href="`/servicio/` + item.slug" class="tramite-servicio-item">
                            <img loading="lazy" width="69" height="60" class="tramite-servicio-item__icono" :src="'/img/icono-hexagono-' + item.secretaria.icono + '.svg'" alt="" />
                            <div class="tramite-servicio-item__info">
                                <div class="tramite-servicio-item__nombre">{{ item.nombre }}</div>
                                <div class="tramite-servicio-item__secretaria">{{ item.secretaria.nombre }}</div>
                            </div>
                            <div class="tramite-servicio-item__modalidades">
                                <span v-if="item.presencial == 1" class="badge etiqueta-simple etiqueta-simple__gris">Presencial</span>
                                <span v-if="item.enlinea == 1" class="badge etiqueta-simple etiqueta-simple__verde">En
                                    Línea</span>
                            </div>
                            </Link>
                        </div>
                        <div class="row" v-if="servicios.total > limit">
                            <div class="col-12">
                                <Paginacion :links="servicios.links" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    ref
} from 'vue'
import NoResults from "../../Shared/Utils/NoResults.vue";
import {
    Link
} from '@inertiajs/inertia-vue3'
import Paginacion from '../../Shared/Paginacion.vue';
import {
    Inertia
} from '@inertiajs/inertia';
import 'vue3-carousel/dist/carousel.css';
import {
    Carousel,
    Slide,
    Navigation,
    Pagination
} from 'vue3-carousel';

export default {
    props: {
        servicios: Object,
        secretarias: Object,
        frecuentes: Object,
        limit: Number,
        filters: Object,
    },
    data() {
        return {
            search: this.filters.search,
            secretaria: (this.filters.secretaria == null) ? '' : this.filters.secretaria,
            enlinea: (this.filters.enlinea == null) ? '' : this.filters.enlinea,
            settings: {
                itemsToShow: 1,
                snapAlign: 'start',
            },
            breakpoints: {
                300: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
                500: {
                    itemsToShow: 2,
                    snapAlign: 'start',
                },
                700: {
                    itemsToShow: 3,
                    snapAlign: 'start',
                },
                1024: {
                    itemsToShow: 4,
                    snapAlign: 'start',
                },
            },
        }
    },
    components: {
        NoResults,
        Link,
        Paginacion,
        Carousel,
        Slide,
        Navigation,
        Pagination,
    },
    methods: {
        searching() {
            Inertia.get('/servicios', {
                search: this.search,
                secretaria: this.secretaria,
                enlinea: this.enlinea,
            }, {
                preserveState: true,
                preserveScroll: true,
                replace: true
            })
        },
        next() {
            this.$refs.itemsFrecuentes.next()
        },
        prev() {
            this.$refs.itemsFrecuentes.prev()
        }
    }
}
</script>
<style scoped>
.slider-tramites-servicios .tramite-servicio-item {
    text-align: left;
}

.bot-buscar {
    width: 150px;
    height: 50px;
    padding-top: 10px;
}

.carousel__pagination .carousel__pagination-button {
    width: 10px !important;
    height: 12px !important;
    border-radius: 50% !important;
}

.slider-tramites-servicios .tramite-servicio-item {
    margin-right: 0;
    padding-right: 20px;
}

.tramite-servicio-item__secretaria a {
    color: inherit;
}
</style>
